import { h } from 'preact';

import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';

import Header from '../header/header.jsx';
import Main from '../main/main.jsx';
import Sidebar from '../sidebar/sidebar.jsx';
import ChangesSidebar from '../changesSidebar/changesSidebar.jsx';
import getStore from '../../store/index.js';
import LruSidebar from '../lruSidebar/lruSidebar.jsx';
import Copilot from '../../copilot/index.jsx';

const store = getStore();

const mdTheme = createTheme({
  typography: {
    fontSize: 14,
  },
});

function Dashboard(_props) {
  return (
    <div id="preact_root">
      <Provider store={store}>
        <ThemeProvider theme={mdTheme}>
          <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Header />
            <Sidebar />
            <LruSidebar />
            <ChangesSidebar />
            <Main />
            <Copilot />
          </Box>
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default Dashboard;
